import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './OilTankComponent.metadata.json5';

function OilTankComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OilTankComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const oilTankVisible = () => { 
        if(submissionVM.lobData.perLine.coverables.mobileHomeCoverable.mobileHomes.value[0].utilities.auxHeaFueTypFie === 'Oil') {
            return true
        } 

        return false
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        yeaInsFie: {
            required: oilTankVisible()
        },
        ageoftheOilTanFie: {
            required: oilTankVisible()
        },
        ifOthExpFie: {
            visible: _.get(modelVM, 'oilTanLocFie.value.code') === "Other"
        },
        addOilTanInsFie: {
            required: oilTankVisible()
        },
        oilTanTypFie: {
            required: oilTankVisible()
        },
        conAppLabFie: {
            required: oilTankVisible()
        },
        ifothdesFie: {
            visible: _.get(modelVM, 'conAppLabFie.value.code') === "Other"
        },
        spiProFie: {
            required: oilTankVisible()
        },
        tanSupBasConFie: {
            required: oilTankVisible()
        },
        istanfaswitabraforstaFie: {
            required: oilTankVisible()
        },
        ifinsistanfilandveoutFie: {
            required: oilTankVisible()
        },
        isvenstalochigthafpipFie: {
            required: oilTankVisible()
        },
        anyrusdenoreviofcocorFie: {
            required: oilTankVisible()
        },
        aretheanysigofleaaelsFie: {
            required: oilTankVisible()
        },
        ifyesspethedetfilpdraFie: {
            visible: _.get(modelVM, 'aretheanysigofleaaelsFie.value') === true
        },
        arefumorodoeviFie: {
            required: oilTankVisible()
        },
        istaninsandserannFie: {
            required: oilTankVisible()
        },
        istansaffrovehimpFie: {
            required: oilTankVisible()
        },
        isthe61cm2feeofclerelFie: {
            required: oilTankVisible()
        },
        hasthetanbeepaiforproFie: {
            required: oilTankVisible()
        },
        isthefuesuplinprofdamFie: {
            required: oilTankVisible()
        },
        istanfilregkeethettanFie: {
            required: oilTankVisible()
        },
        isthetanlocatlea16souFie: {
            required: oilTankVisible()
        },
        istheanyrusdenorevcorFie: {
            required: oilTankVisible()
        },
        wheisthelinfillocihouFie: {
            required: oilTankVisible()
        },
        isthefuelinprowheifouFie: {
            required: oilTankVisible()
        },
        wheisthetanoutlocsfurFie: {
            required: oilTankVisible()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OilTankComponent.propTypes = wizardProps;
export default withRouter(OilTankComponent);